import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]     = useState(null);
  const [token, setToken]   = useState(() => localStorage.getItem('cockpit_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          // Verificar se há userData salvo (com encoding correto)
          const savedUser = localStorage.getItem('cockpit_user');
          if (savedUser) {
            setUser(JSON.parse(savedUser));
          } else {
            setUser(payload);
          }
        } else {
          localStorage.removeItem('cockpit_token');
          localStorage.removeItem('cockpit_user');
          setToken(null);
        }
      } catch {
        localStorage.removeItem('cockpit_token');
        localStorage.removeItem('cockpit_user');
        setToken(null);
      }
    }
    setLoading(false);
  }, []);

  const login = (tkn, userData) => {
    localStorage.setItem('cockpit_token', tkn);
    setToken(tkn);
    if (userData) {
      // Salvar userData da API (encoding correto)
      localStorage.setItem('cockpit_user', JSON.stringify(userData));
      setUser(userData);
    } else {
      setUser(JSON.parse(atob(tkn.split('.')[1])));
    }
  };

  const logout = () => {
    localStorage.removeItem('cockpit_token');
    localStorage.removeItem('cockpit_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
